import { IEquipeVendasUsuarioGeral } from "../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";
import {
    DesvincularEquipeVendasUsuarioService,
    ListarEquipeVendasDesvinculadosPorUsuarioService,
    ListarEquipeVendasVinculadosPorUsuarioService,
    VincularEquipeVendasUsuarioService,
} from "../../../Services/Geral/EquipeVendas/EquipeVendasService";
import { Controller } from "../../Controller";

export function ListarEquipeVendasDesvinculadosPorUsuarioController(
    IDUsuario: number
) {
    return Controller(
        ListarEquipeVendasDesvinculadosPorUsuarioService(IDUsuario)
    );
}

export function ListarEquipeVendasVinculadosPorUsuarioController(
    IDUsuario: number
) {
    return Controller(ListarEquipeVendasVinculadosPorUsuarioService(IDUsuario));
}

export function VincularEquipeVendasUsuarioController(
    requestBody: Array<IEquipeVendasUsuarioGeral>
) {
    return Controller(VincularEquipeVendasUsuarioService(requestBody));
}

export function DesvincularEquipeVendasUsuarioController(
    requestBody: Array<number>
) {
    return Controller(DesvincularEquipeVendasUsuarioService(requestBody));
}
